import { render } from "./SectionNewsHorisontal2.vue?vue&type=template&id=7dc7b672&scoped=true"
import script from "./SectionNewsHorisontal2.vue?vue&type=script&lang=js"
export * from "./SectionNewsHorisontal2.vue?vue&type=script&lang=js"

import "./SectionNewsHorisontal2.vue?vue&type=style&index=0&id=7dc7b672&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dc7b672"]])

export default __exports__